import React from 'react';
//
// https://atlaskit.atlassian.com/packages/core/icon/docs/using-custom-icons
//

export const AtlassianWarnWithoutBorder = () => (
  <svg width="24" height="24" viewBox="3 3 17 17" focusable="false" role="presentation">
    <g fillRule="evenodd">
      <path
        d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z"
        fill="currentColor"
      ></path>
      <path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"></path>
    </g>
  </svg>
);

export const AtlassianLockedWithoutBorder = () => (
  <svg width="24" height="24" viewBox="4 4 16 16" focusable="false" role="presentation">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 10V8.002A4.004 4.004 0 0112 4a4 4 0 014 4.002V10a2 2 0 012 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 016 18v-6c0-1.102.897-1.995 2-2zm2 0h4V8.002A2.001 2.001 0 0012 6c-1.102 0-2 .898-2 2.002V10zm2 7a2 2 0 100-4 2 2 0 000 4z"
    ></path>
  </svg>
);
// WITHOUT HEIGHT IT DOES NOT WORK :( IE11 NEEDS WIDTH TOO!!!
export const FieldEditorSortIcon = () => (
  <svg viewBox="0 0 24 24" height="24" width="24" focusable="false" role="presentation">
    <g fill="currentColor">
      <path
        d="M17.936 4.014a.52.52 0 0 1 .412.268c.955 2.12 1.751 4.3 2.626 6.45a.46.46 0 0 1-.054.411.517.517 0 0 1-.372.22c-.48.017-.995.081-1.162-.304l-.444-1.143-2.874.023-.45 1.124c-.288.653-1.818.46-1.596-.303.814-2.18 1.793-4.301 2.69-6.451.173-.375.745-.31 1.224-.295zm-1.24 4.395h1.68l-.855-2.095c-.274.699-.55 1.397-.825 2.095zm3.271 5.216c.558.056.583.956.359 1.255l-3.758 4.646h3.393c.14.006.148.018.205.043.554.239.487 1.338-.17 1.404-1.74.06-3.48.002-5.221.002-.55-.019-.672-.884-.393-1.256l3.758-4.646h-2.996c-.14-.006-.148-.018-.205-.043-.555-.239-.495-1.338.17-1.405a71.856 71.856 0 0 1 4.858 0z"
        fillRule="nonzero"
      />
      <path d="M6.995 7v9.588l-1.28-1.273a1.014 1.014 0 0 0-1.42 0 .996.996 0 0 0 0 1.416l2.993 2.977a1.014 1.014 0 0 0 1.424 0l2.993-2.977a.996.996 0 0 0 0-1.416 1.014 1.014 0 0 0-1.42 0l-1.28 1.273V7c0-.552-.45-1-1.004-1-.555 0-1.006.448-1.006 1z" />
    </g>
  </svg>
);

// WITHOUT HEIGHT IT DOES NOT WORK :( IE11 NEEDS WIDTH TOO!!!
export const ChessQueenIcon = () => (
  <svg viewBox="0 0 24 24" height="24" width="24" focusable="false" role="presentation" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g fill="currentColor">
      <path d="M1.627 3.31s3.78 11.988 4.388 14.657c.114.504-.635.857-.635 1.36 0 .506.285.944.735.98.023.002 11.642.027 11.665.027.485-.002.755-.43.735-.952-.019-.524-.745-.925-.63-1.415.63-2.678 4.518-14.656 4.518-14.656l-7.587 6.814L12.02 3.31l-2.73 6.83-7.662-6.83z" />
      <circle cx="3.958" cy="5.913" r="1.327" transform="matrix(1.28567 0 0 1.28567 -3.282 -3.766)" />
      <circle cx="3.958" cy="5.913" r="1.327" transform="matrix(1.28567 0 0 1.28567 17.105 -3.766)" />
      <circle cx="3.958" cy="5.913" r="1.327" transform="translate(5.062 -7.895) scale(1.753)" />
      <path d="M19.129 22.855a1 1 0 0 0-1-.999H5.871a1 1 0 0 0-1 1v.002a1 1 0 0 0 1 1H18.13a1 1 0 0 0 1-1v-.003z" />
    </g>
  </svg>
);

// WITHOUT HEIGHT IT DOES NOT WORK :( IE11 NEEDS WIDTH TOO!!!
export const ChessPawnIcon = () => (
  <svg viewBox="0 0 24 24" height="24" width="24" focusable="false" role="presentation" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g fill="currentColor">
      <path d="M19.11 22.901a.998.998 0 0 0-.998-.996H5.888a.998.998 0 0 0-.997.996v.003c0 .55.447.996.997.996h12.224c.55 0 .998-.446.998-.996V22.9zM5.836 18.814l6.173-14.149 6.14 14.161c.26.612.454 1.564-.67 1.539-.09-.001-10.864.02-10.894.022-1.123.021-1.038-.89-.75-1.573z" />
      <circle cx="11.612" cy="6.981" r="3.373" transform="matrix(1.3323 0 0 1.3323 -3.47 -4.708)" />
    </g>
  </svg>
);

// WITHOUT HEIGHT IT DOES NOT WORK :( IE11 NEEDS WIDTH TOO!!!
export const StarLineIcon = () => (
  <svg viewBox="0 0 24 24" height="24" width="24" focusable="false" role="presentation" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g fill="currentColor">
      <path d="M12 17.872l5.504 3.032-1.05-6.437 4.53-4.628-6.257-.955L12 3.094 9.274 8.887l-6.257.953 4.53 4.626-1.053 6.437L12 17.872zm0 3.157l-4.17 2.298c-.41.225-.869.343-1.335.343a2.778 2.778 0 0 1-2.73-3.212l.829-5.056-3.554-3.629a2.767 2.767 0 0 1-.79-1.936c0-1.36 1.006-2.529 2.351-2.734l4.799-.73 2.099-4.458A2.77 2.77 0 0 1 12 .329a2.77 2.77 0 0 1 2.502 1.586l2.1 4.458 4.8.73a2.774 2.774 0 0 1 2.349 2.734 2.77 2.77 0 0 1-.791 1.936l-3.553 3.629.828 5.056a2.778 2.778 0 0 1-2.73 3.214c-.467 0-.926-.12-1.335-.345L12 21.029z" />
    </g>
  </svg>
);

// WITHOUT HEIGHT IT DOES NOT WORK :( IE11 NEEDS WIDTH TOO!!!
export const StarFillIcon = () => (
  <svg viewBox="0 0 24 24" height="24" width="24" focusable="false" role="presentation" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
    <g fill="currentColor">
      <path d="M12 21.029l-4.17 2.298c-.41.225-.869.343-1.335.343a2.778 2.778 0 0 1-2.73-3.212l.829-5.056-3.554-3.629a2.767 2.767 0 0 1-.79-1.936c0-1.36 1.006-2.529 2.351-2.734l4.799-.73 2.099-4.458A2.77 2.77 0 0 1 12 .329a2.77 2.77 0 0 1 2.502 1.586l2.1 4.458 4.8.73a2.774 2.774 0 0 1 2.349 2.734 2.77 2.77 0 0 1-.791 1.936l-3.553 3.629.828 5.056a2.778 2.778 0 0 1-2.73 3.214c-.467 0-.926-.12-1.335-.345L12 21.029z" />
    </g>
  </svg>
);
